import {
  createBadge as publicCreateBadge,
  getBadge as publicGetBadge,
  queryBadges as publicQueryBadges,
  typedQueryBadges as publicTypedQueryBadges,
  updateBadge as publicUpdateBadge,
  deleteBadge as publicDeleteBadge,
  updateBadgesDisplayOrder as publicUpdateBadgesDisplayOrder,
  moveBadge as publicMoveBadge,
} from './badges-v4-badge-badges-v-2.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  BadgeQuery,
  BadgesQueryBuilder,
  typedQueryBadges as universalTypedQueryBadges,
} from './badges-v4-badge-badges-v-2.universal.js';
import { onBadgeCreated as publicOnBadgeCreated } from './badges-v4-badge-badges-v-2.public.js';
import { onBadgeDeleted as publicOnBadgeDeleted } from './badges-v4-badge-badges-v-2.public.js';
import { onBadgeUpdated as publicOnBadgeUpdated } from './badges-v4-badge-badges-v-2.public.js';

function customQueryBadges(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryBadges(httpClient)(),
    typedQueryFunction: (query: BadgeQuery) =>
      publicTypedQueryBadges(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): BadgesQueryBuilder;
  function overloadedQuery(
    query: BadgeQuery
  ): ReturnType<typeof universalTypedQueryBadges>;
  function overloadedQuery(query?: BadgeQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createBadge: MaybeContext<
  BuildRESTFunction<typeof publicCreateBadge> & typeof publicCreateBadge
> = /*#__PURE__*/ createRESTModule(publicCreateBadge);
export const getBadge: MaybeContext<
  BuildRESTFunction<typeof publicGetBadge> & typeof publicGetBadge
> = /*#__PURE__*/ createRESTModule(publicGetBadge);
export const updateBadge: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBadge> & typeof publicUpdateBadge
> = /*#__PURE__*/ createRESTModule(publicUpdateBadge);
export const deleteBadge: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBadge> & typeof publicDeleteBadge
> = /*#__PURE__*/ createRESTModule(publicDeleteBadge);
export const updateBadgesDisplayOrder: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBadgesDisplayOrder> &
    typeof publicUpdateBadgesDisplayOrder
> = /*#__PURE__*/ createRESTModule(publicUpdateBadgesDisplayOrder);
export const moveBadge: MaybeContext<
  BuildRESTFunction<typeof publicMoveBadge> & typeof publicMoveBadge
> = /*#__PURE__*/ createRESTModule(publicMoveBadge);
export const queryBadges: MaybeContext<
  BuildRESTFunction<typeof customQueryBadges> & typeof customQueryBadges
> = /*#__PURE__*/ createRESTModule(customQueryBadges);
/**
 * Triggered when a badge is created.
 */
export const onBadgeCreated: BuildEventDefinition<typeof publicOnBadgeCreated> &
  typeof publicOnBadgeCreated = createEventModule(publicOnBadgeCreated);
/**
 * Triggered when a badge is deleted.
 */
export const onBadgeDeleted: BuildEventDefinition<typeof publicOnBadgeDeleted> &
  typeof publicOnBadgeDeleted = createEventModule(publicOnBadgeDeleted);
/**
 * Triggered when a badge is updated.
 */
export const onBadgeUpdated: BuildEventDefinition<typeof publicOnBadgeUpdated> &
  typeof publicOnBadgeUpdated = createEventModule(publicOnBadgeUpdated);

export {
  SortOrder,
  Position,
  WebhookIdentityType,
} from './badges-v4-badge-badges-v-2.universal.js';
export {
  Badge,
  MigrationBadgeUpdated,
  MigrationBadge,
  MigrationBadgeCreated,
  CreateBadgeRequest,
  CreateBadgeResponse,
  GetBadgeRequest,
  GetBadgeResponse,
  QueryBadgesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryBadgesResponse,
  CursorPagingMetadata,
  Cursors,
  QueryBadgesLegacyRequest,
  Paging,
  QueryBadgesLegacyResponse,
  PagingMetadata,
  UpdateBadgeRequest,
  UpdateBadgeResponse,
  DeleteBadgeRequest,
  DeleteBadgeResponse,
  UpdateBadgesDisplayOrderRequest,
  UpdateBadgesDisplayOrderResponse,
  MoveBadgeRequest,
  MoveBadgeResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BadgeCreatedEnvelope,
  BadgeDeletedEnvelope,
  BadgeUpdatedEnvelope,
  BadgesQueryResult,
  BadgesQueryBuilder,
  BadgeQuerySpec,
  UpdateBadge,
  MoveBadgeOptions,
} from './badges-v4-badge-badges-v-2.universal.js';
export { utils } from './badges-v4-badge-badges-v-2.universal.js';
export {
  SortOrderWithLiterals,
  PositionWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateBadgeValidationErrors,
  CommonQueryWithEntityContext,
  BadgeQuery,
} from './badges-v4-badge-badges-v-2.universal.js';
